export const oasDescriptions = {
  attributeFilters: {
    value: 'Attribute filters to be applied on present columns.',
  },
  pagination: {
    value: 'Pagination parameters.',
    limit: {
      value: 'Number of items to be returned.',
    },
    start: {
      value: 'Number of items to be skipped.',
    },
  },
  report: {
    value: 'Report to be used for the request.',
    string: {
      title: 'report web-endpoint',
      value: 'Report web-endpoint used for report grouping.',
    },
    array: {
      title: 'report ids',
      itemTitle: 'Names of the reports to be used for the request.',
    },
  },
  snapshot: {
    uuid: {
      title: 'uuid',
      value: 'UUID of the snapshot.',
    },
    $last: {
      title: '$last',
      value: 'Last snapshot.',
    },
    $prev: {
      title: '$prev',
      value: 'Previous snapshot.',
    },
    $lastLocked: {
      title: '$lastLocked',
      value: 'Last locked snapshot.',
    },
  },
  tables: {
    columns: {
      value: 'Column names to be returned.',
    },
    filters: {
      value: 'Filters to be applied on present columns.',
      array: {
        containsAll: {
          title: 'array contains all',
          keyword: 'Keyword to check if the array contains all of the values.',
          value: (arrayName: string) =>
            `Array of values all be present in the "${arrayName}" array.` as const,
        },
        containsAny: {
          title: 'array contains any',
          keyword: 'Keyword to check if the array contains any of the values.',
          value: (arrayName: string) =>
            `Array of values any of them be present in the "${arrayName}" array.` as const,
        },
        notContainsAny: {
          title: 'array does not contain any',
          keyword:
            'Keyword to check if the array does not contain any of the values.',
          value: (arrayName: string) =>
            `Array of values none of them be present in the "${arrayName}" array.` as const,
        },
        empty: {
          title: 'array is empty',
          keyword: 'Keyword to check if the array is empty or not.',
          value: 'Value whether the array is empty or not.',
        },
        eq: {
          title: 'array equals',
          keyword: 'Keyword to check if the array equals to the value.',
          value: 'Array of values to compare with.',
        },
        all: {
          keyword:
            'Keyword to check if every array items fulfill the condition.',
        },
        any: {
          keyword: 'Keyword to check if any array item fulfill the condition.',
        },
      },
      boolean: {
        value: {
          title: 'boolean',
          operation: 'Operator to be used for boolean comparison.',
          value: 'Value used for boolean comparison.',
        },
        empty: {
          title: 'empty / not empty',
          keyword: 'Keyword to check if the value is empty or not.',
          value: 'Value whether the value is empty or not.',
        },
        column: {
          title: 'compare with column',
          keyword: 'Keyword to compare with another column.',
          operation: 'Operator to be used for boolean comparison.',
          value: 'Column name to compare with.',
        },
      },
      date: {
        value: {
          title: 'compare with value',
          operation: 'Operator to be used for numeric comparison.',
          value: 'Number value (milliseconds) used for date comparison.',
        },
        now: {
          title: 'compare with now',
          keyword: 'Keyword to compare with the current date.',
          operation: 'Operator to be used for numeric comparison.',
          value:
            'Number value (amount of days) used for date comparison with now.',
        },
        empty: {
          title: 'empty / not empty',
          keyword: 'Keyword to check if the value is empty or not.',
          value: 'Value whether the value is empty or not.',
        },
        column: {
          title: 'compare with column',
          keyword: 'Keyword to compare with another column.',
          operation: 'Operator to be used for numeric comparison.',
          value: 'Column name to compare with.',
        },
      },
      discontiguousRouting: {
        value: {
          title: 'compare with value',
          operation:
            'Operator to be used for discontiguous routing comparison.',
          value: 'Value used for discontiguous routing comparison.',
        },
        ip: {
          title: 'compare with ip',
          keyword: 'Keyword to compare with ip address.',
          value: 'IPv4 address to compare with.',
        },
        empty: {
          title: 'empty / not empty',
          keyword: 'Keyword to check if the value is empty or not.',
          value: 'Value whether the value is empty or not.',
        },
        column: {
          title: 'compare with column',
          keyword: 'Keyword to compare with another column.',
          operation:
            'Operator to be used for discontiguous routing comparison.',
          value: 'Column name to compare with.',
        },
      },
      ip: {
        value: {
          title: 'compare with value',
          operation: 'Operator to be used for ip comparison.',
          value: 'Value used for ip comparison.',
        },
        cidr: {
          title: 'compare with CIDR',
          keyword: 'Keyword to compare with CIDR.',
          value: 'CIDR to compare with.',
        },
        empty: {
          title: 'empty / not empty',
          keyword: 'Keyword to check if the value is empty or not.',
          value: 'Value whether the value is empty or not.',
        },
        column: {
          title: 'compare with column',
          keyword: 'Keyword to compare with another column.',
          operation: 'Operator to be used for ip comparison.',
          value: 'Column name to compare with.',
        },
      },
      ipv6: {
        value: {
          title: 'compare with value',
          operation: 'Operator to be used for ipv6 comparison.',
          value: 'Value used for ipv6 comparison.',
        },
        cidr: {
          title: 'compare with CIDR',
          keyword: 'Keyword to compare with CIDR.',
          value: 'CIDR to compare with.',
        },
        empty: {
          title: 'empty / not empty',
          keyword: 'Keyword to check if the value is empty or not.',
          value: 'Value whether the value is empty or not.',
        },
        column: {
          title: 'compare with column',
          keyword: 'Keyword to compare with another column.',
          operation: 'Operator to be used for ipv6 comparison.',
          value: 'Column name to compare with.',
        },
      },
      ipv6routing: {
        value: {
          title: 'compare with value',
          operation: 'Operator to be used for ipv6 routing comparison.',
          value: 'Value used for ipv6 routing comparison.',
        },
        ip: {
          title: 'compare with ip',
          keyword: 'Keyword to compare with ip address.',
          value: 'IPv6 address to compare with.',
        },
        empty: {
          title: 'empty / not empty',
          keyword: 'Keyword to check if the value is empty or not.',
          value: 'Value whether the value is empty or not.',
        },
        column: {
          title: 'compare with column',
          keyword: 'Keyword to compare with another column.',
          operation: 'Operator to be used for ipv6 routing comparison.',
          value: 'Column name to compare with.',
        },
      },

      number: {
        value: {
          title: 'compare with value',
          operation: 'Operator to be used for numeric comparison.',
          value: 'Value used for numeric comparison.',
        },
        empty: {
          title: 'empty / not empty',
          keyword: 'Keyword to check if the value is empty or not.',
          value: 'Value whether the value is empty or not.',
        },
        column: {
          title: 'compare with column',
          keyword: 'Keyword to compare with another column.',
          operation: 'Operator to be used for numeric comparison.',
          value: 'Column name to compare with.',
        },
      },

      object: {
        value: (propertyName: string): string =>
          `"${propertyName}" - Name of the object key.`,
      },
      routing: {
        value: {
          title: 'compare with value',
          operation: 'Operator to be used for routing comparison.',
          value: 'Value used for routing comparison.',
        },
        ip: {
          title: 'compare with ip',
          keyword: 'Keyword to compare with ip address.',
          operation: 'Operator to be used for routing comparison.',
          value: 'IPv4 address to compare with.',
        },
        cidr: {
          title: 'compare with CIDR',
          operation: 'Operator to be used for routing comparison.',
          value: 'CIDR to compare with.',
        },
        empty: {
          title: 'empty / not empty',
          keyword: 'Keyword to check if the value is empty or not.',
          value: 'Value whether the value is empty or not.',
        },
        column: {
          title: 'compare with column',
          keyword: 'Keyword to compare with another column.',
          operation: 'Operator to be used for routing comparison.',
          value: 'Column name to compare with.',
        },
      },
      string: {
        value: {
          title: 'compare with value',
          operation: 'Operator to be used for string comparison.',
          value: 'Value used for string comparison.',
        },
        empty: {
          title: 'empty / not empty',
          keyword: 'Keyword to check if the value is empty or not.',
          value: 'Value whether the value is empty or not.',
        },
        column: {
          title: 'compare with column',
          keyword: 'Keyword to compare with another column.',
          operation: 'Operator to be used for string comparison.',
          value: 'Column name to compare with.',
        },
      },
      referenceId: {
        value: {
          title: 'compare with value',
          operation: 'Operator to be used for reference ID comparison.',
          value: 'Value used for reference ID comparison.',
        },
        column: {
          title: 'compare with column',
          keyword: 'Keyword to compare with another column.',
          operation: 'Operator to be used for reference ID comparison.',
          value: 'Column name to compare with.',
        },
      },
      default: {
        value: {
          title: 'compare with value',
          operation: 'Operator to be used for string comparison.',
          value: 'Value used for string comparison.',
        },
        nonNullable: {
          title: 'strictly compare with value',
          operation: 'Operator to be used for string comparison.',
          value: 'Value used for string comparison.',
        },
        empty: {
          title: 'empty / not empty',
          keyword: 'Keyword to check if the value is empty or not.',
          value: 'Value whether the value is empty or not.',
        },
        column: {
          title: 'compare with column',
          keyword: 'Keyword to compare with another column.',
          operation: 'Operator to be used for string comparison.',
          value: 'Column name to compare with.',
        },
      },
      deviceAttribute: {
        value: 'attribute name',
      },
    },
    data: {
      severity: {
        s0: 'severity 0 success green',
        s10: 'severity 10 info blue',
        s20: 'severity 20 warning yellow',
        s30: 'severity 30 error red',
      },
      string: {
        value: 'value',
        valueWithSeverity: 'value with severity',
      },
      number: {
        value: 'value',
        valueWithSeverity: 'value with severity',
      },
      integer: {
        value: 'value',
        valueWithSeverity: 'value with severity',
      },
      boolean: {
        value: 'value',
        valueWithSeverity: 'value with severity',
      },
      date: {
        value: 'value (number representation of date)',
        valueWithSeverity:
          'value (number representation of date) with severity',
      },
      discontiguousRouting: {
        value: 'value',
        valueWithSeverity: 'value with severity',
      },
      ip: {
        value: 'value',
        valueWithSeverity: 'value with severity',
      },
      ipv6: {
        value: 'value',
        valueWithSeverity: 'value with severity',
      },
      ipv6routing: {
        value: 'value',
        valueWithSeverity: 'value with severity',
      },
      routing: {
        value: 'value',
        valueWithSeverity: 'value with severity',
      },
      default: {
        value: 'value',
        valueWithSeverity: 'value with severity',
      },
    },
  },
} as const;
